import React from 'react'
import { ButtonProps } from '@ui/buttons/Button/types'
import {
  interpolateColor,
  useAnimatedStyle,
  useDerivedValue,
} from 'react-native-reanimated'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import Button from '@ui/buttons/Button'
import { buttonThemeBack, buttonThemeBorder, buttonThemeFront } from './style'

interface Props extends ButtonProps {
  theme: 'light' | 'dark'
}

export default function ButtonTheme(props: Props) {
  const { animation, onPressIn, onPressOut } = useAnimatedPress()
  const variant = props.variant || 'filled'
  const theme = props.theme || 'light'
  const variantDerived = useDerivedValue(() => variant)
  const themeDerived = useDerivedValue(() => theme)

  const style = useAnimatedStyle(() => {
    return {
      backgroundColor: interpolateColor(
        animation.value,
        [0, 1],
        [
          buttonThemeBack[themeDerived.value][variantDerived.value][0],
          buttonThemeBack[themeDerived.value][variantDerived.value][1],
        ]
      ),
      borderColor: interpolateColor(
        animation.value,
        [0, 1],
        [
          buttonThemeBorder[themeDerived.value][variantDerived.value][0],
          buttonThemeBorder[themeDerived.value][variantDerived.value][1],
        ]
      ),
    }
  })

  return (
    <Button
      {...props}
      onPressIn={onPressIn}
      onPressOut={onPressOut}
      style={style}
      overrideColorFront={buttonThemeFront[theme][variant]}
    />
  )
}
